/* ============
 * VMP Sync Page
 * ============
 *
 * This is the page for adding product.
 */
import { mapGetters, mapMutations } from 'vuex';
import productTransformer from '../../../../transformers/productVmpSync';
import vmpService from './../../../../services/vinmonopolet';

export default {
  data() {
    return {
      products: {
        forUpdate: [],
        forInsert: [],
      },
      newProductsSelection: [],
      existingProductsSelection: [],
      defaultProductTypeName: '',
      loading: false,
      syncLoading: false,
      prechecked: 0,
      tabIndex: '1',
      selectedFields: [],
      productsPackaging: [],
      results: [],
    };
  },
  computed: {
    newProducts() {
      return this.newProductsSelection.map(p => (this.getPackaging(p)));
    },
    existingProducts() {
      return this.existingProductsSelection.map(p => (this.getPackaging(p)));
    },
    syncDate() {
      if (this.products.forInsert.length) {
        return this.products.forInsert[0].syncDate;
      }
      if (this.products.forUpdate.length) {
        return this.products.forUpdate[0].syncDate;
      }
      return '';
    },
  },
  created() {
    this.startSync(false);
  },
  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      setModalSize: 'SET_MODAL_SIZE',
      setModalButtonLoading: 'SET_MODAL_BUTTON_LOADING',
      setModalClass: 'SET_MODAL_CLASS',
    }),

    startSync(isVmpSync) {
      this.syncLoading = true;
      this.results = [];
      this.newProductsSelection = [];
      this.existingProductsSelection = [];
      vmpService
        .syncSelected({ precheck: 1, vmp_sync: isVmpSync })
        .then((data) => {
          this.products.forInsert = productTransformer.fetchCollection(
            data.for_insert
          );
          this.products.forUpdate = productTransformer.fetchCollection(
            data.for_update
          );
          if (!this.products.forInsert.length &&
            !this.products.forUpdate.length
          ) {
            if (isVmpSync) {
              this.$message({
                message: this.$t('static.products.syncVmp.noDataToBeSynced'),
                type: 'error',
              });
            }
          } else {
            this.prechecked = 1;
          }
          this.syncLoading = false;
        })
        .catch(() => {
          this.syncLoading = false;
        });
    },
    processSync() {
      if (!this.existingProductsSelection.length) {
        this.confirmSync();
        return;
      }
      this.showFieldsModal();
    },
    showFieldsModal() {
      this.setModalContent(() =>
        require('./../../../../components/vmpSyncFieldsPopup/vmpSyncFieldsPopup.vue')
      );
      this.setModalSize('full');
      this.toggleModal(true);
      this.setModalShowClose(false);
      this.setModalProps({
        selectedFields: this.selectedFields,
        onConfirm: this.saveFields,
        result: this.results,
        hasNewSelection: !!this.newProductsSelection.length,
        onClose: () => this.startSync(false),
      });
      this.setModalClass('');
    },
    showPackagingModal(productsNoPackaging) {
      this.setModalContent(() =>
        require('./../../../../components/vmpSyncPackagingPopup/vmpSyncPackagingPopup.vue')
      );
      this.setModalSize('100%');
      this.setModalClass('vmp-packaging');
      this.toggleModal(true);
      this.setModalProps({
        productsNoPackaging,
        onConfirm: this.confirmSync,
        onUpdatePackaging: this.updatePackaging,
        onPackagingCreate: () => this.checkMissingPackaging(true),
      });
    },
    saveFields(fields) {
      this.selectedFields = fields;
      this.confirmSync();
    },
    updatePackaging(product) {
      if (!product) return;
      const index = this.productsPackaging.findIndex(p => +p.id === product.id);
      if (index !== -1) {
        this.productsPackaging[index].productPackagingId = product.productPackagingId;
      } else {
        this.productsPackaging.push({
          id: product.id,
          productPackagingId: product.productPackagingId,
        });
      }
    },
    getPackaging(product) {
      let packagingId = product.productPackagingId;
      if (!packagingId) {
        const p = this.productsPackaging.find(packaging => +packaging.id === +product.id);
        if (p) {
          packagingId = p.productPackagingId;
        }
      }
      return {
        id: product.id,
        productPackagingId: packagingId,
        vmp: product.vmp,
        name: product.name,
        alcoholPercentage: product.alcoholPercentage,
        bottleVolume: product.bottleVolume,
        packagingMaterialId: product.packagingMaterialId,
        packagingName: product.packagingName,
        packagingQuantity: product.packagingQuantity,
      };
    },
    checkMissingPackaging(forceShowModal = false) {
      const products = [...this.newProducts, ...this.existingProducts];
      const productsNoPackaging = products.filter(
        p => !p.productPackagingId || (forceShowModal && this.productsPackaging.find(pp => +pp.id === +p.id))
      );
      if (productsNoPackaging.length || forceShowModal) {
        this.showPackagingModal(productsNoPackaging);
        return true;
      }
      return false;
    },
    confirmSync() {
      if (this.checkMissingPackaging()) return;

      this.syncLoading = true;
      const params = {
        selected: {
          new: this.newProducts.map(p => ({ id: p.id, product_packaging_id: p.productPackagingId })),
          existing: this.existingProducts.map(p => ({ id: p.id, product_packaging_id: p.productPackagingId })),
        },
        fields: this.selectedFields,
      };
      vmpService
        .syncSelected(params)
        .then((data) => {
          this.prechecked = 1;
          this.syncLoading = false;

          if (data.result.length) {
            this.results = data.result;
            this.showFieldsModal();
            return;
          }
        })
        .catch(() => {
          this.syncLoading = false;
          this.$message({
            message: this.$t('static.products.syncVmp.syncError'),
            type: 'error',
          });
        });
    },
    cancelSync() {
      this.products.forInsert = [];
      this.products.forUpdate = [];
      this.prechecked = 0;
      this.syncLoading = false;
      this.results = [];
    },
    restartSync() {
      this.results = [];
      this.startSync(false);
    },
    handleNewProductsSelectionChange(val) {
      this.newProductsSelection = val;
    },
    handleExistingProductsSelectionChange(val) {
      this.existingProductsSelection = val;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/products/syncVmp/syncVmp.js